const UnCheckIcon = () => (
    <div className="unchecked-div check-icon">
      <svg width="12" height="12" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
        <path fill="white" fillRule="nonzero" d="M1.829 6.825a.832.832 0 0 0 1.162.02l4.733-4.46a.833.833 0 1 0-1.142-1.211L2.44 5.076 1.434 4.06A.833.833 0 1 0 .25 5.232l1.578 1.593z">
        </path>
      </svg>
    </div>
  )
  export default UnCheckIcon;